/* eslint-disable import/first */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Type } from '@spotify-internal/encore-creator-web';
import styles from './index.module.scss';
import {
  LOADING,
  ERROR,
  selectPodcastStartsStreams,
  selectPodcastStartsStreamsStatus,
  selectDateRange,
} from 'store/selectors.ts';
import { loadPodcastStartsStreams } from 'store/podcastStartsStreams.ts';
import { StartsStreams } from 'components/Shared/Charts/StartsStreamsChart';
import { LoadingIndicator } from 'components/Shared/LoadingIndicator';
import { FormattedMessage } from 'react-intl';

export class PodcastStartsStreamsContainer extends PureComponent {
  static propTypes = {
    podcastStartsStreams: PropTypes.arrayOf(
      PropTypes.shape({
        date: PropTypes.string.isRequired,
        starts: PropTypes.number.isRequired,
        streams: PropTypes.number.isRequired,
      }),
    ),
    status: PropTypes.oneOf([LOADING, ERROR]),
    dateRange: PropTypes.shape({
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
    loadPodcastStartsStreams: PropTypes.func.isRequired,
    podcastId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.props.loadPodcastStartsStreams(this.props.podcastId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.dateRange) return;

    if (
      nextProps.dateRange.startDate !== this.props.dateRange.startDate ||
      nextProps.dateRange.endDate !== this.props.dateRange.endDate
    ) {
      this.props.loadPodcastStartsStreams(this.props.podcastId);
    }
  }

  render() {
    switch (this.props.status) {
      case ERROR:
        return <span data-qa="podcast-starts-streams-error" />;
      default:
        break;
    }

    if (!this.props.podcastStartsStreams && this.props.status !== LOADING) return null;

    return (
      <div data-qa="podcast-starts-streams-chart">
        <div className={styles.header}>
          <Type as="p" variant={Type.heading3}>
            <FormattedMessage
              id="podcast.audience.starts-streams"
              defaultMessage="Starts & Streams"
            />
          </Type>
        </div>
        {this.props.status === LOADING ? (
          <div style={{ width: '100%', height: '350px' }}>
            <LoadingIndicator />
          </div>
        ) : (
          <StartsStreams startsStreams={this.props.podcastStartsStreams} />
        )}
      </div>
    );
  }
}

const selector = createStructuredSelector({
  podcastStartsStreams: selectPodcastStartsStreams,
  status: selectPodcastStartsStreamsStatus,
  dateRange: selectDateRange,
});

const actions = { loadPodcastStartsStreams };

export const ConnectedPodcastStartsStreamsContainer = connect(
  selector,
  actions,
)(PodcastStartsStreamsContainer);
